/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Tree_Expand_LabelInputs */

const en_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand`)
};

const fr_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developper`)
};

const de_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandieren`)
};

const it_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandere`)
};

const ru_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширять`)
};

const es_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir`)
};

const zh_cn2_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩张`)
};

const ja_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大する`)
};

const hi_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बढ़ाना`)
};

const pt_pt2_explorer_tree_expand_label = /** @type {(inputs: Explorer_Tree_Expand_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir`)
};

/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Explorer_Tree_Expand_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_tree_expand_label = /** @type {((inputs?: Explorer_Tree_Expand_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Tree_Expand_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_tree_expand_label(inputs)
	if (locale === "de") return de_explorer_tree_expand_label(inputs)
	if (locale === "it") return it_explorer_tree_expand_label(inputs)
	if (locale === "ru") return ru_explorer_tree_expand_label(inputs)
	if (locale === "es") return es_explorer_tree_expand_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_tree_expand_label(inputs)
	if (locale === "ja") return ja_explorer_tree_expand_label(inputs)
	if (locale === "hi") return hi_explorer_tree_expand_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_tree_expand_label(inputs)
	return en_explorer_tree_expand_label(inputs)
});